export default class DoughnutOptions {
    public width:number = 500;
    public height:number = 500;
    public doughnutRatio = 0.4;
    public data:Promise<any> = Promise.resolve([]);
    public iconUrl?:string = undefined;
}
